//////////////////////////////////////
// CARDCHASE EMAIL SERVICE (Resend)
// Uses usernames only - never real names
//////////////////////////////////////

import { supabase } from './supabase';

const RESEND_API_KEY = process.env.REACT_APP_RESEND_API_KEY;
const RESEND_API_URL = 'https://api.resend.com/emails';

// Logo hosted on cardchase.org (or use placeholder if not available)
const LOGO_URL = 'https://dpbwqvmiocwkalqbbhbb.supabase.co/storage/v1/object/public/assets/logo512.png';

//////////////////////////////////////
// EMAIL TEMPLATES
//////////////////////////////////////

const createTradeConfirmationEmail = (username, partnerUsername, emailData) => {
  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Trade Confirmed - CardChase</title>
</head>
<body style="margin: 0; padding: 0; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; background-color: #f8fafc;">
  <div style="max-width: 520px; margin: 0 auto; background-color: #ffffff; border-radius: 12px; margin-top: 24px; margin-bottom: 24px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">

    <!-- Header -->
    <div style="background-color: #0ea5e9; padding: 24px; text-align: center;">
      <img src="${LOGO_URL}" alt="CardChase" style="height: 48px; width: auto; margin-bottom: 12px;" />
      <h1 style="color: #ffffff; margin: 0; font-size: 22px; font-weight: 600;">Trade Confirmed</h1>
    </div>

    <!-- Content -->
    <div style="padding: 28px 24px;">
      <p style="color: #334155; font-size: 16px; margin: 0 0 20px 0; line-height: 1.5;">
        Hey <strong>@${username}</strong>, your trade is scheduled!
      </p>

      <!-- Trade Details Card -->
      <div style="background-color: #f1f5f9; border-radius: 8px; padding: 20px; margin-bottom: 20px;">
        <div style="margin-bottom: 14px;">
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Trading With</span>
          <p style="color: #0f172a; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">@${partnerUsername}</p>
        </div>
        <div style="margin-bottom: 14px;">
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Card</span>
          <p style="color: #0f172a; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">${emailData.card}</p>
        </div>
        <div style="margin-bottom: 14px;">
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Date & Time</span>
          <p style="color: #0f172a; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">${emailData.day}, ${emailData.date} at ${emailData.time}</p>
        </div>
        <div>
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Location</span>
          <p style="color: #0f172a; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">${emailData.location?.store_name || 'TBD'}</p>
          <p style="color: #475569; font-size: 14px; margin: 2px 0 0 0;">${emailData.location?.address || ''}</p>
          <p style="color: #475569; font-size: 14px; margin: 2px 0 0 0;">${emailData.location?.city || ''}, ${emailData.location?.state || ''} ${emailData.location?.zip_code || ''}</p>
        </div>
      </div>

      <!-- Tips -->
      <div style="background-color: #fef9c3; border-left: 3px solid #eab308; padding: 12px 14px; border-radius: 0 6px 6px 0; margin-bottom: 20px;">
        <p style="color: #854d0e; font-size: 13px; margin: 0; line-height: 1.5;">
          <strong>Tip:</strong> Arrive on time and verify the card's condition before completing the trade.
        </p>
      </div>

      <!-- CTA Button -->
      <div style="text-align: center;">
        <a href="https://cardchase.org" style="display: inline-block; background-color: #0ea5e9; color: #ffffff; text-decoration: none; padding: 12px 28px; border-radius: 8px; font-weight: 600; font-size: 14px;">
          Open CardChase
        </a>
      </div>
    </div>

    <!-- Footer -->
    <div style="background-color: #f8fafc; padding: 16px 24px; text-align: center; border-top: 1px solid #e2e8f0;">
      <p style="color: #94a3b8; font-size: 12px; margin: 0;">
        Happy trading! - The CardChase Team
      </p>
    </div>

  </div>
</body>
</html>
  `;
};

const createBusinessNotificationEmail = (emailData, user1Username, user2Username) => {
  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Trade Scheduled - CardChase</title>
</head>
<body style="margin: 0; padding: 0; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; background-color: #f8fafc;">
  <div style="max-width: 520px; margin: 0 auto; background-color: #ffffff; border-radius: 12px; margin-top: 24px; margin-bottom: 24px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">

    <!-- Header -->
    <div style="background-color: #0ea5e9; padding: 24px; text-align: center;">
      <img src="${LOGO_URL}" alt="CardChase" style="height: 48px; width: auto; margin-bottom: 12px;" />
      <h1 style="color: #ffffff; margin: 0; font-size: 22px; font-weight: 600;">Trade Scheduled at Your Location</h1>
    </div>

    <!-- Content -->
    <div style="padding: 28px 24px;">
      <p style="color: #334155; font-size: 16px; margin: 0 0 20px 0; line-height: 1.5;">
        A card trade has been scheduled at <strong>${emailData.location?.store_name}</strong>.
      </p>

      <!-- Trade Details Card -->
      <div style="background-color: #f1f5f9; border-radius: 8px; padding: 20px; margin-bottom: 20px;">
        <div style="margin-bottom: 14px;">
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Traders</span>
          <p style="color: #0f172a; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">@${user1Username} & @${user2Username}</p>
        </div>
        <div style="margin-bottom: 14px;">
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Date & Time</span>
          <p style="color: #0f172a; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">${emailData.day}, ${emailData.date} at ${emailData.time}</p>
        </div>
        <div>
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Card Being Traded</span>
          <p style="color: #0f172a; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">${emailData.card}</p>
        </div>
      </div>

      <!-- Info Box -->
      <div style="background-color: #dcfce7; border-left: 3px solid #22c55e; padding: 12px 14px; border-radius: 0 6px 6px 0;">
        <p style="color: #166534; font-size: 13px; margin: 0; line-height: 1.5;">
          <strong>FYI:</strong> Two CardChase users will be meeting at your store. No action required.
        </p>
      </div>
    </div>

    <!-- Footer -->
    <div style="background-color: #f8fafc; padding: 16px 24px; text-align: center; border-top: 1px solid #e2e8f0;">
      <p style="color: #94a3b8; font-size: 12px; margin: 0;">
        Thank you for supporting the trading card community!
      </p>
    </div>

  </div>
</body>
</html>
  `;
};

//////////////////////////////////////
// RESEND API FUNCTIONS
//////////////////////////////////////

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const sendEmailViaResend = async (to, subject, htmlContent) => {
  try {
    console.log('[Email] Sending to:', to);

    const response = await fetch(RESEND_API_URL, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${RESEND_API_KEY}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        from: 'CardChase <noreply@mysendz.com>',
        to: [to],
        subject: subject,
        html: htmlContent,
        tags: [{ name: 'category', value: 'trade-confirmation' }]
      }),
    });

    if (!response.ok) {
      const errorData = await response.text();
      console.error('[Email] Resend API error:', response.status, errorData);

      if (response.status === 429) {
        throw new Error('Rate limit exceeded');
      }
      return false;
    }

    const data = await response.json();
    console.log('[Email] Sent successfully:', data.id);
    return true;
  } catch (error) {
    console.error('[Email] Error:', error);
    if (error.message === 'Rate limit exceeded') throw error;
    return false;
  }
};

const sendEmailWithRetry = async (to, subject, htmlContent, retries = 3) => {
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      const success = await sendEmailViaResend(to, subject, htmlContent);
      if (success) return true;
      if (attempt === retries) return false;
      await delay(1000 * attempt);
    } catch (error) {
      console.error(`[Email] Attempt ${attempt} failed:`, error);
      if (attempt === retries) return false;
      await delay(1000 * attempt);
    }
  }
  return false;
};

//////////////////////////////////////
// MAIN EXPORT FUNCTIONS
//////////////////////////////////////

/**
 * Send trade confirmation emails to both users (and optionally the business)
 * @param {Object} emailData - Trade details
 * @param {string} emailData.tradeId - Trade ID
 * @param {string} emailData.cardOwnerId - Card owner's user ID
 * @param {string} emailData.requesterId - Requester's user ID
 * @param {Object} emailData.location - Location object with store_name, address, city, state, zip_code
 * @param {string} emailData.date - Date string (e.g., "December 15, 2025")
 * @param {string} emailData.day - Day of week (e.g., "Monday")
 * @param {string} emailData.time - Time string (e.g., "3:00 PM")
 * @param {string} emailData.card - Card name
 */
export const sendTradeConfirmationEmails = async (emailData) => {
  try {
    console.log('[Email] Starting trade confirmation emails:', emailData);

    if (!RESEND_API_KEY) {
      console.error('[Email] REACT_APP_RESEND_API_KEY not configured');
      return { success: false, error: 'API key not configured' };
    }

    // Fetch both users' data (username + email)
    const { data: cardOwnerData, error: ownerError } = await supabase
      .from('users')
      .select('id, username, email')
      .eq('id', emailData.cardOwnerId)
      .single();

    const { data: requesterData, error: requesterError } = await supabase
      .from('users')
      .select('id, username, email')
      .eq('id', emailData.requesterId)
      .single();

    if (ownerError || requesterError) {
      console.error('[Email] User fetch error:', ownerError || requesterError);
      return { success: false, error: 'Failed to fetch user data' };
    }

    if (!cardOwnerData?.email || !requesterData?.email) {
      console.error('[Email] Missing email addresses');
      return { success: false, error: 'Missing email addresses' };
    }

    const ownerUsername = cardOwnerData.username || 'user';
    const requesterUsername = requesterData.username || 'user';

    // Fetch business email if location exists
    let businessEmail = null;
    if (emailData.location?.id) {
      const { data: locationData } = await supabase
        .from('locations')
        .select('email')
        .eq('id', emailData.location.id)
        .single();

      if (locationData?.email) {
        businessEmail = locationData.email;
      }
    }

    // Fetch parent emails for under-18 traders
    const parentEmails = [];
    for (const traderId of [emailData.cardOwnerId, emailData.requesterId]) {
      const { data: parentLinks } = await supabase
        .from('family_links')
        .select('parent_id')
        .eq('child_id', traderId);

      if (parentLinks?.length) {
        for (const link of parentLinks) {
          const { data: parentData } = await supabase
            .from('users')
            .select('email, username')
            .eq('id', link.parent_id)
            .single();
          if (parentData?.email) {
            const childUsername = traderId === emailData.cardOwnerId ? ownerUsername : requesterUsername;
            parentEmails.push({ email: parentData.email, childUsername });
          }
        }
      }
    }

    // Fetch staff emails for the location
    const staffEmails = [];
    if (emailData.location?.id) {
      const { data: staff } = await supabase
        .from('location_staff')
        .select('user_id')
        .eq('location_id', emailData.location.id)
        .eq('status', 'active');

      if (staff?.length) {
        for (const s of staff) {
          const { data: staffUser } = await supabase
            .from('users')
            .select('email')
            .eq('id', s.user_id)
            .single();
          if (staffUser?.email) {
            staffEmails.push(staffUser.email);
          }
        }
      }
    }

    console.log('[Email] Sending to:', {
      owner: cardOwnerData.email,
      requester: requesterData.email,
      business: businessEmail,
      parents: parentEmails.map(p => p.email),
      staff: staffEmails,
    });

    // Send emails sequentially (rate limiting)
    const results = [];

    // Email to card owner
    const ownerHtml = createTradeConfirmationEmail(ownerUsername, requesterUsername, emailData);
    results.push(await sendEmailWithRetry(cardOwnerData.email, `Trade Confirmed - ${emailData.card}`, ownerHtml));
    await delay(600);

    // Email to requester
    const requesterHtml = createTradeConfirmationEmail(requesterUsername, ownerUsername, emailData);
    results.push(await sendEmailWithRetry(requesterData.email, `Trade Confirmed - ${emailData.card}`, requesterHtml));

    // Email to business (if applicable)
    if (businessEmail) {
      await delay(600);
      const businessHtml = createBusinessNotificationEmail(emailData, ownerUsername, requesterUsername);
      results.push(await sendEmailWithRetry(businessEmail, `Trade Scheduled at ${emailData.location?.store_name}`, businessHtml));
    }

    // Email to parents of under-18 traders
    for (const parent of parentEmails) {
      await delay(600);
      const parentHtml = createTradeConfirmationEmail(parent.childUsername, parent.childUsername === ownerUsername ? requesterUsername : ownerUsername, emailData);
      await sendEmailWithRetry(parent.email, `Trade Confirmed for @${parent.childUsername} - ${emailData.card}`, parentHtml);
    }

    // Email to location staff
    const uniqueStaffEmails = [...new Set(staffEmails)].filter(e => e !== businessEmail);
    for (const staffEmail of uniqueStaffEmails) {
      await delay(600);
      const staffHtml = createBusinessNotificationEmail(emailData, ownerUsername, requesterUsername);
      await sendEmailWithRetry(staffEmail, `Trade Scheduled at ${emailData.location?.store_name}`, staffHtml);
    }

    const [ownerSent, requesterSent, businessSent = true] = results;
    const success = ownerSent && requesterSent;

    console.log('[Email] Results:', { ownerSent, requesterSent, businessSent, parentsSent: parentEmails.length, staffSent: uniqueStaffEmails.length, success });

    return { success, ownerSent, requesterSent, businessSent };
  } catch (error) {
    console.error('[Email] sendTradeConfirmationEmails error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Validate email data before sending
 */
export const validateEmailData = (emailData) => {
  return !!(
    emailData.tradeId &&
    emailData.cardOwnerId &&
    emailData.requesterId &&
    emailData.location &&
    emailData.date &&
    emailData.day &&
    emailData.time &&
    emailData.card
  );
};

//////////////////////////////////////
// LOCATION CLAIM & DISPUTE EMAILS
//////////////////////////////////////

const createClaimSubmittedEmail = (username, storeName) => {
  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Claim Received - CardChase</title>
</head>
<body style="margin: 0; padding: 0; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; background-color: #f8fafc;">
  <div style="max-width: 520px; margin: 0 auto; background-color: #ffffff; border-radius: 12px; margin-top: 24px; margin-bottom: 24px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">

    <div style="background-color: #0ea5e9; padding: 24px; text-align: center;">
      <img src="${LOGO_URL}" alt="CardChase" style="height: 48px; width: auto; margin-bottom: 12px;" />
      <h1 style="color: #ffffff; margin: 0; font-size: 22px; font-weight: 600;">Claim Received</h1>
    </div>

    <div style="padding: 28px 24px;">
      <p style="color: #334155; font-size: 16px; margin: 0 0 20px 0; line-height: 1.5;">
        Hey <strong>@${username}</strong>, we received your claim for <strong>${storeName}</strong>.
      </p>

      <div style="background-color: #f1f5f9; border-radius: 8px; padding: 20px; margin-bottom: 20px;">
        <div style="margin-bottom: 14px;">
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Location</span>
          <p style="color: #0f172a; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">${storeName}</p>
        </div>
        <div>
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Status</span>
          <p style="color: #f59e0b; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">Pending Review</p>
        </div>
      </div>

      <div style="background-color: #dbeafe; border-left: 3px solid #3b82f6; padding: 12px 14px; border-radius: 0 6px 6px 0; margin-bottom: 20px;">
        <p style="color: #1e40af; font-size: 13px; margin: 0; line-height: 1.5;">
          Our team will review your claim and verify your ownership. This typically takes 1-3 business days. We may contact you at your provided phone number or email.
        </p>
      </div>

      <div style="text-align: center;">
        <a href="https://cardchase.org" style="display: inline-block; background-color: #0ea5e9; color: #ffffff; text-decoration: none; padding: 12px 28px; border-radius: 8px; font-weight: 600; font-size: 14px;">
          Open CardChase
        </a>
      </div>
    </div>

    <div style="background-color: #f8fafc; padding: 16px 24px; text-align: center; border-top: 1px solid #e2e8f0;">
      <p style="color: #94a3b8; font-size: 12px; margin: 0;">
        The CardChase Team
      </p>
    </div>

  </div>
</body>
</html>
  `;
};

const createClaimApprovedEmail = (username, storeName) => {
  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Claim Approved - CardChase</title>
</head>
<body style="margin: 0; padding: 0; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; background-color: #f8fafc;">
  <div style="max-width: 520px; margin: 0 auto; background-color: #ffffff; border-radius: 12px; margin-top: 24px; margin-bottom: 24px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">

    <div style="background-color: #22c55e; padding: 24px; text-align: center;">
      <img src="${LOGO_URL}" alt="CardChase" style="height: 48px; width: auto; margin-bottom: 12px;" />
      <h1 style="color: #ffffff; margin: 0; font-size: 22px; font-weight: 600;">You're Verified!</h1>
    </div>

    <div style="padding: 28px 24px;">
      <p style="color: #334155; font-size: 16px; margin: 0 0 20px 0; line-height: 1.5;">
        Congratulations <strong>@${username}</strong>! Your claim for <strong>${storeName}</strong> has been approved.
      </p>

      <div style="background-color: #f1f5f9; border-radius: 8px; padding: 20px; margin-bottom: 20px;">
        <div style="margin-bottom: 14px;">
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Location</span>
          <p style="color: #0f172a; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">${storeName}</p>
        </div>
        <div>
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Status</span>
          <p style="color: #22c55e; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">Verified Partner</p>
        </div>
      </div>

      <p style="color: #334155; font-size: 14px; margin: 0 0 20px 0; line-height: 1.5;">
        You now have full access to your location dashboard. You can manage operating hours, create events, and add staff members.
      </p>

      <div style="text-align: center;">
        <a href="https://cardchase.org" style="display: inline-block; background-color: #22c55e; color: #ffffff; text-decoration: none; padding: 12px 28px; border-radius: 8px; font-weight: 600; font-size: 14px;">
          Manage Your Location
        </a>
      </div>
    </div>

    <div style="background-color: #f8fafc; padding: 16px 24px; text-align: center; border-top: 1px solid #e2e8f0;">
      <p style="color: #94a3b8; font-size: 12px; margin: 0;">
        Welcome to the CardChase Partner Program!
      </p>
    </div>

  </div>
</body>
</html>
  `;
};

const createClaimDeniedEmail = (username, storeName, reason) => {
  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Claim Update - CardChase</title>
</head>
<body style="margin: 0; padding: 0; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; background-color: #f8fafc;">
  <div style="max-width: 520px; margin: 0 auto; background-color: #ffffff; border-radius: 12px; margin-top: 24px; margin-bottom: 24px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">

    <div style="background-color: #64748b; padding: 24px; text-align: center;">
      <img src="${LOGO_URL}" alt="CardChase" style="height: 48px; width: auto; margin-bottom: 12px;" />
      <h1 style="color: #ffffff; margin: 0; font-size: 22px; font-weight: 600;">Claim Update</h1>
    </div>

    <div style="padding: 28px 24px;">
      <p style="color: #334155; font-size: 16px; margin: 0 0 20px 0; line-height: 1.5;">
        Hey <strong>@${username}</strong>, unfortunately your claim for <strong>${storeName}</strong> was not approved.
      </p>

      <div style="background-color: #f1f5f9; border-radius: 8px; padding: 20px; margin-bottom: 20px;">
        <div style="margin-bottom: 14px;">
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Location</span>
          <p style="color: #0f172a; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">${storeName}</p>
        </div>
        <div>
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Reason</span>
          <p style="color: #ef4444; font-size: 14px; font-weight: 500; margin: 4px 0 0 0;">${reason || 'Unable to verify ownership at this time.'}</p>
        </div>
      </div>

      <p style="color: #334155; font-size: 14px; margin: 0 0 20px 0; line-height: 1.5;">
        If you believe this was an error, you can submit a new claim with additional verification details, or contact our support team.
      </p>

      <div style="text-align: center;">
        <a href="mailto:tradersupport@cardchase.org" style="display: inline-block; background-color: #0ea5e9; color: #ffffff; text-decoration: none; padding: 12px 28px; border-radius: 8px; font-weight: 600; font-size: 14px;">
          Contact Support
        </a>
      </div>
    </div>

    <div style="background-color: #f8fafc; padding: 16px 24px; text-align: center; border-top: 1px solid #e2e8f0;">
      <p style="color: #94a3b8; font-size: 12px; margin: 0;">
        The CardChase Team
      </p>
    </div>

  </div>
</body>
</html>
  `;
};

const createDisputeSubmittedEmail = (username, storeName) => {
  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Dispute Received - CardChase</title>
</head>
<body style="margin: 0; padding: 0; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; background-color: #f8fafc;">
  <div style="max-width: 520px; margin: 0 auto; background-color: #ffffff; border-radius: 12px; margin-top: 24px; margin-bottom: 24px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">

    <div style="background-color: #f59e0b; padding: 24px; text-align: center;">
      <img src="${LOGO_URL}" alt="CardChase" style="height: 48px; width: auto; margin-bottom: 12px;" />
      <h1 style="color: #ffffff; margin: 0; font-size: 22px; font-weight: 600;">Dispute Received</h1>
    </div>

    <div style="padding: 28px 24px;">
      <p style="color: #334155; font-size: 16px; margin: 0 0 20px 0; line-height: 1.5;">
        Hey <strong>@${username}</strong>, we received your ownership dispute for <strong>${storeName}</strong>.
      </p>

      <div style="background-color: #fef9c3; border-left: 3px solid #eab308; padding: 12px 14px; border-radius: 0 6px 6px 0; margin-bottom: 20px;">
        <p style="color: #854d0e; font-size: 13px; margin: 0; line-height: 1.5;">
          Our team will review your dispute and any supporting documents you provided. We may contact both parties for additional information. This process typically takes 3-5 business days.
        </p>
      </div>

      <div style="text-align: center;">
        <a href="https://cardchase.org" style="display: inline-block; background-color: #0ea5e9; color: #ffffff; text-decoration: none; padding: 12px 28px; border-radius: 8px; font-weight: 600; font-size: 14px;">
          Open CardChase
        </a>
      </div>
    </div>

    <div style="background-color: #f8fafc; padding: 16px 24px; text-align: center; border-top: 1px solid #e2e8f0;">
      <p style="color: #94a3b8; font-size: 12px; margin: 0;">
        The CardChase Team
      </p>
    </div>

  </div>
</body>
</html>
  `;
};

const createDisputeNotifyOwnerEmail = (ownerUsername, storeName) => {
  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Ownership Dispute Filed - CardChase</title>
</head>
<body style="margin: 0; padding: 0; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; background-color: #f8fafc;">
  <div style="max-width: 520px; margin: 0 auto; background-color: #ffffff; border-radius: 12px; margin-top: 24px; margin-bottom: 24px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">

    <div style="background-color: #f59e0b; padding: 24px; text-align: center;">
      <img src="${LOGO_URL}" alt="CardChase" style="height: 48px; width: auto; margin-bottom: 12px;" />
      <h1 style="color: #ffffff; margin: 0; font-size: 22px; font-weight: 600;">Ownership Dispute Notice</h1>
    </div>

    <div style="padding: 28px 24px;">
      <p style="color: #334155; font-size: 16px; margin: 0 0 20px 0; line-height: 1.5;">
        Hey <strong>@${ownerUsername}</strong>, someone has filed an ownership dispute for <strong>${storeName}</strong>.
      </p>

      <div style="background-color: #fef9c3; border-left: 3px solid #eab308; padding: 12px 14px; border-radius: 0 6px 6px 0; margin-bottom: 20px;">
        <p style="color: #854d0e; font-size: 13px; margin: 0; line-height: 1.5;">
          Our team will review the dispute. Your location access remains unchanged while the review is in progress. We may contact you for additional verification. No action is needed from you at this time.
        </p>
      </div>

      <div style="text-align: center;">
        <a href="mailto:tradersupport@cardchase.org" style="display: inline-block; background-color: #0ea5e9; color: #ffffff; text-decoration: none; padding: 12px 28px; border-radius: 8px; font-weight: 600; font-size: 14px;">
          Contact Support
        </a>
      </div>
    </div>

    <div style="background-color: #f8fafc; padding: 16px 24px; text-align: center; border-top: 1px solid #e2e8f0;">
      <p style="color: #94a3b8; font-size: 12px; margin: 0;">
        The CardChase Team
      </p>
    </div>

  </div>
</body>
</html>
  `;
};

/**
 * Send claim submitted confirmation email
 */
export const sendClaimSubmittedEmail = async (claimantUserId, locationId) => {
  try {
    if (!RESEND_API_KEY) return { success: false, error: 'API key not configured' };

    const { data: userData } = await supabase
      .from('users')
      .select('username, email')
      .eq('id', claimantUserId)
      .single();

    const { data: locData } = await supabase
      .from('locations')
      .select('store_name')
      .eq('id', locationId)
      .single();

    if (!userData?.email || !locData?.store_name) return { success: false, error: 'Missing data' };

    const html = createClaimSubmittedEmail(userData.username || 'user', locData.store_name);
    const success = await sendEmailWithRetry(userData.email, `Claim Received - ${locData.store_name}`, html);

    return { success };
  } catch (error) {
    console.error('[Email] sendClaimSubmittedEmail error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Send claim decision email (approved or denied)
 */
export const sendClaimDecisionEmail = async (claimantUserId, locationId, approved, reason) => {
  try {
    if (!RESEND_API_KEY) return { success: false, error: 'API key not configured' };

    const { data: userData } = await supabase
      .from('users')
      .select('username, email')
      .eq('id', claimantUserId)
      .single();

    const { data: locData } = await supabase
      .from('locations')
      .select('store_name')
      .eq('id', locationId)
      .single();

    if (!userData?.email || !locData?.store_name) return { success: false, error: 'Missing data' };

    const username = userData.username || 'user';
    const html = approved
      ? createClaimApprovedEmail(username, locData.store_name)
      : createClaimDeniedEmail(username, locData.store_name, reason);

    const subject = approved
      ? `Welcome to CardChase - ${locData.store_name}`
      : `Claim Update - ${locData.store_name}`;

    const success = await sendEmailWithRetry(userData.email, subject, html);
    return { success };
  } catch (error) {
    console.error('[Email] sendClaimDecisionEmail error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Send dispute notification emails to disputant and current owner
 */
export const sendDisputeEmails = async (disputantUserId, currentOwnerId, locationId) => {
  try {
    if (!RESEND_API_KEY) return { success: false, error: 'API key not configured' };

    const { data: locData } = await supabase
      .from('locations')
      .select('store_name')
      .eq('id', locationId)
      .single();

    if (!locData?.store_name) return { success: false, error: 'Missing location data' };

    // Email to disputant
    const { data: disputantData } = await supabase
      .from('users')
      .select('username, email')
      .eq('id', disputantUserId)
      .single();

    if (disputantData?.email) {
      const html = createDisputeSubmittedEmail(disputantData.username || 'user', locData.store_name);
      await sendEmailWithRetry(disputantData.email, `Dispute Received - ${locData.store_name}`, html);
    }

    // Email to current owner
    if (currentOwnerId) {
      await delay(600);
      const { data: ownerData } = await supabase
        .from('users')
        .select('username, email')
        .eq('id', currentOwnerId)
        .single();

      if (ownerData?.email) {
        const html = createDisputeNotifyOwnerEmail(ownerData.username || 'user', locData.store_name);
        await sendEmailWithRetry(ownerData.email, `Ownership Dispute - ${locData.store_name}`, html);
      }
    }

    return { success: true };
  } catch (error) {
    console.error('[Email] sendDisputeEmails error:', error);
    return { success: false, error: error.message };
  }
};

//////////////////////////////////////
// TRADE CANCELLATION & RESCHEDULE EMAILS
//////////////////////////////////////

const createCancellationEmail = (recipientUsername, cancellerUsername, emailData, isParent = false, childUsername = null) => {
  const intro = isParent
    ? `A trade for your child <strong>@${childUsername}</strong> has been cancelled by <strong>@${cancellerUsername}</strong>.`
    : `<strong>@${cancellerUsername}</strong> has cancelled the scheduled trade.`;

  const lastMinuteNote = emailData.isLastMinute
    ? `<div style="background-color: #fef2f2; border-left: 3px solid #ef4444; padding: 12px 14px; border-radius: 0 6px 6px 0; margin-bottom: 20px;">
        <p style="color: #991b1b; font-size: 13px; margin: 0; line-height: 1.5;">
          <strong>Note:</strong> This was a last-minute cancellation (less than 24 hours before the trade). This has been recorded on @${cancellerUsername}'s profile.
        </p>
      </div>`
    : '';

  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Trade Cancelled - CardChase</title>
</head>
<body style="margin: 0; padding: 0; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; background-color: #f8fafc;">
  <div style="max-width: 520px; margin: 0 auto; background-color: #ffffff; border-radius: 12px; margin-top: 24px; margin-bottom: 24px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
    <div style="background-color: #ef4444; padding: 24px; text-align: center;">
      <img src="${LOGO_URL}" alt="CardChase" style="height: 48px; width: auto; margin-bottom: 12px;" />
      <h1 style="color: #ffffff; margin: 0; font-size: 22px; font-weight: 600;">Trade Cancelled</h1>
    </div>
    <div style="padding: 28px 24px;">
      <p style="color: #334155; font-size: 16px; margin: 0 0 20px 0; line-height: 1.5;">${intro}</p>
      <div style="background-color: #f1f5f9; border-radius: 8px; padding: 20px; margin-bottom: 20px;">
        <div style="margin-bottom: 14px;">
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Card</span>
          <p style="color: #0f172a; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">${emailData.card}</p>
        </div>
        <div style="margin-bottom: 14px;">
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Was Scheduled For</span>
          <p style="color: #0f172a; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">${emailData.date} at ${emailData.time}</p>
        </div>
        <div>
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Location</span>
          <p style="color: #0f172a; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">${emailData.locationName}</p>
        </div>
      </div>
      ${lastMinuteNote}
      <p style="color: #64748b; font-size: 13px; margin: 0 0 20px 0; line-height: 1.5;">
        @${cancellerUsername} is aware that cancellations are tracked and may impact their trading profile.
      </p>
      <div style="text-align: center;">
        <a href="https://cardchase.org/requests" style="display: inline-block; background-color: #0ea5e9; color: #ffffff; text-decoration: none; padding: 12px 28px; border-radius: 8px; font-weight: 600; font-size: 14px;">
          View Your Trades
        </a>
      </div>
    </div>
    <div style="background-color: #f8fafc; padding: 16px 24px; text-align: center; border-top: 1px solid #e2e8f0;">
      <p style="color: #94a3b8; font-size: 12px; margin: 0;">The CardChase Team</p>
    </div>
  </div>
</body>
</html>
  `;
};

const createRescheduleEmail = (recipientUsername, requesterUsername, emailData, isParent = false, childUsername = null) => {
  const intro = isParent
    ? `<strong>@${requesterUsername}</strong> wants to reschedule a trade with your child <strong>@${childUsername}</strong>.`
    : `<strong>@${requesterUsername}</strong> wants to reschedule your trade.`;

  return `
<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Reschedule Request - CardChase</title>
</head>
<body style="margin: 0; padding: 0; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; background-color: #f8fafc;">
  <div style="max-width: 520px; margin: 0 auto; background-color: #ffffff; border-radius: 12px; margin-top: 24px; margin-bottom: 24px; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
    <div style="background-color: #f59e0b; padding: 24px; text-align: center;">
      <img src="${LOGO_URL}" alt="CardChase" style="height: 48px; width: auto; margin-bottom: 12px;" />
      <h1 style="color: #ffffff; margin: 0; font-size: 22px; font-weight: 600;">Reschedule Request</h1>
    </div>
    <div style="padding: 28px 24px;">
      <p style="color: #334155; font-size: 16px; margin: 0 0 20px 0; line-height: 1.5;">${intro}</p>
      <div style="background-color: #f1f5f9; border-radius: 8px; padding: 20px; margin-bottom: 20px;">
        <div style="margin-bottom: 14px;">
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Originally</span>
          <p style="color: #94a3b8; font-size: 14px; font-weight: 500; margin: 4px 0 0 0; text-decoration: line-through;">${emailData.originalDate} at ${emailData.originalTime}</p>
        </div>
        <div style="margin-bottom: 14px;">
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">New Proposed Time</span>
          <p style="color: #0f172a; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">${emailData.newDate} at ${emailData.newTime}</p>
        </div>
        <div style="margin-bottom: 14px;">
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Location</span>
          <p style="color: #0f172a; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">${emailData.locationName}</p>
        </div>
        <div>
          <span style="color: #64748b; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">Card</span>
          <p style="color: #0f172a; font-size: 16px; font-weight: 600; margin: 4px 0 0 0;">${emailData.card}</p>
        </div>
      </div>
      <div style="background-color: #fef9c3; border-left: 3px solid #eab308; padding: 12px 14px; border-radius: 0 6px 6px 0; margin-bottom: 20px;">
        <p style="color: #854d0e; font-size: 13px; margin: 0; line-height: 1.5;">
          <strong>Action needed:</strong> Open CardChase to accept or decline this reschedule request.
        </p>
      </div>
      <div style="text-align: center;">
        <a href="https://cardchase.org/requests" style="display: inline-block; background-color: #0ea5e9; color: #ffffff; text-decoration: none; padding: 12px 28px; border-radius: 8px; font-weight: 600; font-size: 14px;">
          Respond in CardChase
        </a>
      </div>
    </div>
    <div style="background-color: #f8fafc; padding: 16px 24px; text-align: center; border-top: 1px solid #e2e8f0;">
      <p style="color: #94a3b8; font-size: 12px; margin: 0;">The CardChase Team</p>
    </div>
  </div>
</body>
</html>
  `;
};

/**
 * Send cancellation emails to partner, parents, location, staff
 */
export const sendCancellationEmails = async (cancelData) => {
  try {
    if (!RESEND_API_KEY) return { success: false, error: 'API key not configured' };

    const { cancelledByUserId, otherUserId, tradeId, locationId, date, time, card, isLastMinute } = cancelData;

    const { data: canceller } = await supabase.from('users').select('username').eq('id', cancelledByUserId).single();
    const { data: other } = await supabase.from('users').select('username, email').eq('id', otherUserId).single();
    const cancellerUsername = canceller?.username || 'user';
    const otherUsername = other?.username || 'user';

    let locationName = 'the trade location';
    let locationEmail = null;
    if (locationId) {
      const { data: loc } = await supabase.from('locations').select('store_name, email').eq('id', locationId).single();
      locationName = loc?.store_name || locationName;
      locationEmail = loc?.email;
    }

    const emailData = { card, date, time, locationName, isLastMinute };

    // Email to other trader
    if (other?.email) {
      const html = createCancellationEmail(otherUsername, cancellerUsername, emailData);
      await sendEmailWithRetry(other.email, `Trade Cancelled - ${card}`, html);
      await delay(400);
    }

    // Email to parents of both traders
    for (const userId of [cancelledByUserId, otherUserId]) {
      const { data: parentLinks } = await supabase.from('family_links').select('parent_id').eq('child_id', userId);
      if (parentLinks?.length) {
        const { data: child } = await supabase.from('users').select('username').eq('id', userId).single();
        for (const link of parentLinks) {
          const { data: parent } = await supabase.from('users').select('email').eq('id', link.parent_id).single();
          if (parent?.email) {
            const html = createCancellationEmail(null, cancellerUsername, emailData, true, child?.username);
            await sendEmailWithRetry(parent.email, `Trade Cancelled for @${child?.username} - ${card}`, html);
            await delay(400);
          }
        }
      }
    }

    // Email to location business
    if (locationEmail) {
      const html = createCancellationEmail(null, cancellerUsername, { ...emailData, locationName }, false);
      await sendEmailWithRetry(locationEmail, `Trade Cancelled at ${locationName}`, html);
      await delay(400);
    }

    // Email to location staff
    if (locationId) {
      const { data: staff } = await supabase.from('location_staff').select('user_id').eq('location_id', locationId).eq('status', 'active');
      if (staff?.length) {
        for (const s of staff) {
          const { data: staffUser } = await supabase.from('users').select('email').eq('id', s.user_id).single();
          if (staffUser?.email && staffUser.email !== locationEmail) {
            const html = createCancellationEmail(null, cancellerUsername, { ...emailData, locationName }, false);
            await sendEmailWithRetry(staffUser.email, `Trade Cancelled at ${locationName}`, html);
            await delay(400);
          }
        }
      }
    }

    return { success: true };
  } catch (error) {
    console.error('[Email] sendCancellationEmails error:', error);
    return { success: false, error: error.message };
  }
};

/**
 * Send reschedule request emails to partner, parents, location, staff
 */
export const sendRescheduleEmails = async (rescheduleData) => {
  try {
    if (!RESEND_API_KEY) return { success: false, error: 'API key not configured' };

    const { requestedByUserId, otherUserId, locationId, originalDate, originalTime, newDate, newTime, card } = rescheduleData;

    const { data: requester } = await supabase.from('users').select('username').eq('id', requestedByUserId).single();
    const { data: other } = await supabase.from('users').select('username, email').eq('id', otherUserId).single();
    const requesterUsername = requester?.username || 'user';
    const otherUsername = other?.username || 'user';

    let locationName = 'the trade location';
    let locationEmail = null;
    if (locationId) {
      const { data: loc } = await supabase.from('locations').select('store_name, email').eq('id', locationId).single();
      locationName = loc?.store_name || locationName;
      locationEmail = loc?.email;
    }

    const emailData = { originalDate, originalTime, newDate, newTime, locationName, card };

    // Email to other trader
    if (other?.email) {
      const html = createRescheduleEmail(otherUsername, requesterUsername, emailData);
      await sendEmailWithRetry(other.email, `Reschedule Request - ${card}`, html);
      await delay(400);
    }

    // Email to parents of both traders
    for (const userId of [requestedByUserId, otherUserId]) {
      const { data: parentLinks } = await supabase.from('family_links').select('parent_id').eq('child_id', userId);
      if (parentLinks?.length) {
        const { data: child } = await supabase.from('users').select('username').eq('id', userId).single();
        for (const link of parentLinks) {
          const { data: parent } = await supabase.from('users').select('email').eq('id', link.parent_id).single();
          if (parent?.email) {
            const html = createRescheduleEmail(null, requesterUsername, emailData, true, child?.username);
            await sendEmailWithRetry(parent.email, `Reschedule Request for @${child?.username} - ${card}`, html);
            await delay(400);
          }
        }
      }
    }

    // Email to location
    if (locationEmail) {
      const html = createRescheduleEmail(null, requesterUsername, emailData);
      await sendEmailWithRetry(locationEmail, `Trade Rescheduled at ${locationName}`, html);
      await delay(400);
    }

    return { success: true };
  } catch (error) {
    console.error('[Email] sendRescheduleEmails error:', error);
    return { success: false, error: error.message };
  }
};
